/**
 * Routes the four S8 dialog kinds of the S3 slot to their dialogs (S8 Tasks 8.10 / 8.11). Every S8 dialog targets a
 * Data Lake ref (`hnsPath`); any other resource renders nothing. The dialog reports its draft / request state to the
 * slot through `onGuardChange` (Fable F8), so it is never replaced while it has one.
 */
import type { StorageDialog } from '../../properties/dialogs/storageDialogStore';
import { AclEditorDialog } from './AclEditorDialog';
import { MovePathDialog } from './MovePathDialog';
import { NewDirectoryDialog } from './NewDirectoryDialog';
import { PropagateAclDialog } from './PropagateAclDialog';
import type { HnsDialogOptions, HnsHostedDialogProps } from './hnsDialogTypes';
import { requestHnsRowSelection } from '../hnsSelectionIntent';

type Props = { dialog: StorageDialog; readOnly: boolean; close: () => void; onGuardChange: HnsHostedDialogProps['onGuardChange'] };

export function HnsHostedDialog({ dialog, readOnly, close, onGuardChange }: Props) {
  if (dialog.resource.kind !== 'hnsPath') return null;
  const given: HnsDialogOptions = dialog.hns ?? {};
  // The path a dialog produced (created / renamed / moved) is selected in the tab it was opened from.
  const options: HnsDialogOptions = { ...given, onDone: (resource) => { given.onDone?.(resource); requestHnsRowSelection(given.tabId, resource); } };
  const props: HnsHostedDialogProps = { connectionId: dialog.connectionId, resource: dialog.resource, options, readOnly, onGuardChange, onClose: close };
  switch (dialog.kind) {
    case 'hns-new-directory':
      return <NewDirectoryDialog {...props} />;
    case 'hns-move':
      return <MovePathDialog {...props} />;
    case 'hns-acl':
      return <AclEditorDialog {...props} />;
    case 'hns-acl-propagate':
      return <PropagateAclDialog {...props} />;
    default:
      return null;
  }
}
